<i18n>
{
  "ru": {
    "uploadingFile": "Загрузка файла",
    "uploadedSuccess": "CSV файл успешно загружен",
    "loadFileForProcessing": "Загрузить CSV файл для процессинга",
    "errorCode": "Код ошибки",
    "decodingAndReasons": "Расшифровка / Причины возникновения",
    "recommendation": "Рекомендации",
    "error": "Ошибка",
    "сodeSearch": "Поиск по коду",
    "errorText": "Текст ошибки"
  },
  "en": {
    "uploadingFile": "Uploading a file",
    "uploadedSuccess": "CSV file uploaded successfully",
    "loadFileForProcessing": "Upload a CSV file for processing",
    "errorCode": "Error code",
    "decodingAndReasons": "Decoding / Causes of occurrence",
    "recommendation": "Recommendation",
    "error": "Error",
    "сodeSearch": "Code search",
    "errorText": "Error text"
  }
}
</i18n>
<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="$t('uploadingFile')"
      width="30%"
    >
      <span>{{$t('uploadedSuccess')}} </span>
      <span v-if="ignoredRows">Проигнорировано {{ ignoredRows }} строк(и). См. логи.</span>
    </el-dialog>

    <el-alert v-if="fileUploadErrors.length>0" :title="$t('error')" type="error" effect="dark">
      <li v-for="error in fileUploadErrors">
        {{ error }}
      </li>
    </el-alert>

    <el-tabs type="border-card">
      <template v-for="{name, id, processingErrorInfos} in items">
        <el-tab-pane v-if="processingErrorInfos.length || group==='root'">
          <span slot="label">
            {{ name }}<sup>{{ processingErrorInfos.length }}</sup>
          </span>

          <el-row>
            <el-col :span="3">
              <el-input
                clearable
                v-model="search"
                size="mini"
                :placeholder="$t('сodeSearch')"/>
            </el-col>
            <el-col :span="21">
              <el-upload
                style="float:right"
                v-if="group==='root'"
                :on-success="onSuccess"
                :headers="headers"
                :on-error="onError"
                :show-file-list="false"
                :action="`${billingUrl}/v1/errors-description/upload/processing/${id}`"
                :file-list="fileList">
                <el-button size="small" type="primary">{{$t('loadFileForProcessing')}} <b>{{ name }}</b></el-button>
              </el-upload>
            </el-col>
          </el-row>
          <el-table
            :loading="loading"
            :data="processingErrorInfos.filter(data => !search || data.code.toLowerCase().includes(search.toLowerCase()))"
            stripe
            style="width: 100%;">
            <el-table-column
              prop="code"
              sortable
              :label="$t('errorCode')"
              width="150">
            </el-table-column>
            <el-table-column
              prop="description"
              :label="$t('errorText')">
            </el-table-column>
            <el-table-column
              prop="reason"
              :label="$t('decodingAndReasons')">
            </el-table-column>
            <el-table-column
              prop="recommendation"
              :label="$t('recommendation')">
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </template>
    </el-tabs>
  </div>
</template>
<script>
import apiRes from '../../core/apiRes'

export default {
  name: 'errors',
  data() {
    return {
      billingUrl: process.env.VUE_APP_BILLING_API_URL,
      group: null,
      items: [],
      ignoredRows: 0,
      search: '',
      loading: false,
      dialogVisible: false,
      fileList: [],
      fileUploadErrors: [],
      headers: {
        'Authorization': `Bearer ${window.localStorage.getItem('jwt_token')}`
      },
    }
  },
  methods: {
    parseJwt(token) {
      const base64Url = token.split('.')[1]
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      const jsonPayload = decodeURIComponent(window.atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''))

      return JSON.parse(jsonPayload)
    },
    onSuccess({data: {ignoredRows}}) {
      this.ignoredRows = ignoredRows
      this.dialogVisible = true
      this.fileUploadErrors = []
      this.getErrorInfo()
    },
    onError(error) {
      this.fileUploadErrors = (JSON.parse(error.message)).errors
      if (!Array.isArray(this.fileUploadErrors)) {
        this.fileUploadErrors = [this.fileUploadErrors]
      }
    },
    async getErrorInfo() {
      this.loading = true
      const response = await fetch(`${this.billingUrl}/v1/errors-description`, {
        headers: this.headers,
      })
      const {data} = await response.json()
      this.items = data
      this.loading = false
    }
  },
  created() {
    apiRes.get(apiRes.errorsUrl).then(res => {
    }).finally(() => { this.loading = false })

    if (!window.localStorage.getItem('jwt_token')) {
      alert('JWT токен не найден!')
    }
    this.group = this.parseJwt(window.localStorage.getItem('jwt_token'))['group']
    this.getErrorInfo()
  }
}
</script>
<style scoped>
sup {
  opacity: 0.5
}
</style>
